/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

const Footer = () => {
  return (
    <>
    <footer class="main-footer">

<div class="auto-container">

    {/* <!-- Footer Content --> */}

    <div class="footer-content wow fadeInUp">

        <div class="text-center">

            <div class="footer-logo"><a href="#"><img src="images/logo-2.png" alt=""/></a></div>

            <div class="text">We have very good strength in innovative technology and tools with over 35 years of experience. We makes long-term investments goal in global companies in different sectors, mainly in Europe and other countries.</div> 

        </div>

        <ul class="social-icon-two">

            <li><a href="#"><span class="fab fa-facebook-f"></span></a></li>

            <li><a href="#"><span class="fab fa-pinterest"></span></a></li>

            <li><a href="#"><span class="fab fa-twitter"></span></a></li>

            <li><a href="#"><span class="fab fa-dribbble"></span></a></li>

        </ul>



        <ul class="contact-list-one">

            <li><i class="flaticon-location"></i> 203 Madison Ave, NY, USA <strong>Address</strong></li>

            <li><i class="flaticon-alarm-clock-1"></i>Monday - Friday 9am - 6pm <strong>Timing</strong></li>

            <li><i class="flaticon-email-1"></i> <a href="mailto:boba@gmail.com">boba@gmail.com</a> <strong>Mail to us</strong></li>

        </ul>

    </div>

</div>



<div class="footer-bottom">

    <div class="auto-container">

        <div class="inner-container">

            <ul class="footer-nav">

               <li><a href="#">Terms of Service</a></li> 

               <li><a href="#">Privacy Policy</a></li> 

            </ul>

            

            <div class="copyright-text">

                <p>Copyright © 2023 All Rights Reserved by <a href="#">CPC-75</a></p>

            </div>

        </div>

    </div>

</div>

</footer>

    </>
  )
}

export default Footer